<template>
  <PageHeading
    :has-meta-data="false"
    :has-action-button="true"
    :has-search="true"
    :title="$t('Expert stats')"
    @open="this.openForm = !this.openForm"
    @update:search="$emit('update:search', $event)"
    :hasSearch="false"
  />
  <div :key="form" class="">
    <h1 class="sr-only">Account Settings</h1>
    <header class="border-b w-full">
      <!-- Secondary navigation -->
      <nav class="flex overflow-x-auto py-4 max-w-5xl mx-auto">
        <ul
          role="list"
          class="flex flex-none gap-x-6 px-4 text-sm font-semibold leading-6 text-gray-700 sm:px-6 lg:px-8 items-center"
        >
          <li v-for="item in navigation" :key="item.name">
            <router-link
              :to="`/expert-statistics/configuration/${item.href}`"
              :class="[
                item.current ? 'text-white bg-teal-600' : '',
                'px-2 py-1 rounded-lg hover:bg-teal-600 hover:text-white',
              ]"
              >{{ $t(item.name) }}</router-link
            >
          </li>
        </ul>
      </nav>
    </header>
    <div class="max-w-5xl mx-auto divide-y divide-white/5 pb-5">
      <form
        @submit.prevent="
          menu === 'agent'
            ? sendFormAgentConfiguration()
            : menu === 'queue'
            ? sendFormQueuePreanswerTimeConfiguration()
            : sendForm()
        "
        method="POST"
      >
        <div
          v-if="menu === 'groups'"
          class="py-16 space-y-8 px-4 sm:px-6 lg:px-8"
        >
          <div
            v-for="item in navigation_groups"
            :key="item.name"
            class="grid grid-cols-1 md:grid-cols-3"
          >
            <router-link :to="`/expert-statistics/groups/${item.href}`">
              <h2 class="text-base font-semibold leading-7">
                Configurer un groupe
                {{ item.name === "utilisateurs" ? "d'" : "de " }}{{ item.name }}
              </h2>
            </router-link>
            <!-- <p class="mt-1 text-sm leading-6 text-gray-400">
       Sélectionnez le type de groupe à 
      </p> -->
          </div>

          <!-- <div class="md:col-span-2">
      <div class="grid grid-cols-1 gap-x-6 sm:max-w-xl sm:grid-cols-6">
       <div class="col-span-full">
        <nav class="overflow-x-auto max-w-5xl mx-auto">
         <ul
          role="list"
          class="flex-none space-y-4 px-4 text-sm font-semibold text-gray-700 sm:px-6 lg:px-8 items-center">
          <li v-for="item in navigation_groups" :key="item.name">
           <router-link :to="`/expert-statistics/groups/${item.href}`">{{
            item.name
           }}</router-link>
          </li>
         </ul>
        </nav>
       </div>
      </div>
     </div> -->
        </div>
        <div
          v-if="menu === 'queue'"
          class="grid grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8"
        >
          <div>
            <h2 class="text-base font-semibold leading-7">
              Configuration des files d'attente
            </h2>
            <p class="mt-1 text-sm leading-6 text-gray-400">
              Personnalisez vos files d'attente avec des messages préenregistrés
            </p>
          </div>

          <div class="md:col-span-2">
            <div
              class="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6"
            >
              <div class="col-span-full">
                <div class="items-center text-sm space-y-8">
                  <div class="">
                    <label
                      for="msg_time"
                      class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >{{ $t("Durée du message") }} (seconds)</label
                    >
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input
                        required
                        v-model="this.queue_preanswer_form.preanswer_seconds"
                        type="number"
                        min="0"
                        max="500"
                        id="msg_time"
                        name="msg_time"
                        class="block w-full rounded-md py-1.5 shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 [&_*]:text-black"
                      />
                    </div>
                  </div>
                  <Pbx3cxQueuePreanswerTimeConfiguration
                    :key="selectedPbxElements"
                    @successMsg="successMsg = $event"
                    @success="isSuccess = $event"
                    @clearForm="clearAll"
                    @selectAll="selectAll"
                    :elementsData="elementListConcatReduce"
                    :selectedPbxElements="selectedPbxElements"
                    :groupSelectedFromPbxConfiguration="
                      groupSelectedFromPbxConfiguration
                    "
                    :addElement="addPbxElement"
                    :isEdit="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="menu === 'agent'"
          class="grid grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8"
        >
          <div>
            <h2 class="text-base font-semibold leading-7">
              Statut Personnalisé de l'agent
            </h2>
            <p class="mt-1 text-sm leading-6 text-gray-400">
              Configuration du statut personnalisé de vos agents
            </p>
          </div>

          <div class="md:col-span-2">
            <div
              class="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6"
            >
              <div class="col-span-full">
                <!-- <label class="block text-sm font-medium leading-6">PBX Host</label> -->
                <div class="">
                  <div v-if="hostNames" class="items-center text-sm space-y-8">
                    <!-- <font-awesome-icon
          icon="server"
          class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-600" /> -->

                    <div>
                      <label
                        for="status_custom1"
                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        >Custom 1</label
                      >
                      <input
                        id="status_custom1"
                        type="text"
                        class="block w-full rounded-md py-1.5 shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 [&_*]:text-black"
                        v-model="agentForm.status_custom1"
                      />
                    </div>
                    <div>
                      <label
                        for="status_custom2"
                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        >Custom 2</label
                      >
                      <input
                        id="status_custom2"
                        type="text"
                        class="block w-full rounded-md py-1.5 shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 [&_*]:text-black"
                        v-model="agentForm.status_custom2"
                      />
                    </div>
                  </div>

                  <div
                    v-else
                    class="mt-2 flex items-center text-sm text-gray-600 font-medium"
                  >
                    <!-- <font-awesome-icon
          icon="server"
          class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-600" /> -->
                    <!-- {{ selectHostname ? this.selectHostname : "No 3CX Host" }} -->
                    <select
                      class="block w-full rounded-md py-1.5 shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 [&_*]:text-black"
                    >
                      <option>
                        {{ $t("noHostName") }}
                      </option>
                    </select>
                  </div>
                  <!-- <select
         id="timezone"
         name="timezone"
         class="block w-full rounded-md border-0 bg-white/5 py-1.5 shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 [&_*]:text-black">
         <option>Pacific Standard Time</option>
         <option>Eastern Standard Time</option>
         <option>Greenwich Mean Time</option>
        </select> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="menu === 'pbx'"
          class="grid grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8"
        >
          <div>
            <h2 class="text-base font-semibold leading-7">Domaine PBX</h2>
            <p class="mt-1 text-sm leading-6 text-gray-400">
              Configuration du domaine par défaut
            </p>
          </div>

          <div class="md:col-span-2">
            <div
              class="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6"
            >
              <div class="col-span-full">
                <!-- <label class="block text-sm font-medium leading-6">PBX Host</label> -->
                <div class="">
                  <div v-if="hostNames" class="flex items-center text-sm">
                    <!-- <font-awesome-icon
          icon="server"
          class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-600" /> -->
                    <select
                      required=""
                      class="block w-full rounded-md py-1.5 shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 [&_*]:text-black"
                      v-model="form.host_name"
                    >
                      <option
                        v-for="host in hostNames"
                        :key="host"
                        :value="host"
                      >
                        {{ host }}
                      </option>
                    </select>
                  </div>

                  <div
                    v-else
                    class="mt-2 flex items-center text-sm text-gray-600 font-medium"
                  >
                    <!-- <font-awesome-icon
          icon="server"
          class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-600" /> -->
                    <!-- {{ selectHostname ? this.selectHostname : "No 3CX Host" }} -->
                    <select
                      class="block w-full rounded-md py-1.5 shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 [&_*]:text-black"
                    >
                      <option>
                        {{ $t("noHostName") }}
                      </option>
                    </select>
                  </div>
                  <!-- <select
         id="timezone"
         name="timezone"
         class="block w-full rounded-md border-0 bg-white/5 py-1.5 shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 [&_*]:text-black">
         <option>Pacific Standard Time</option>
         <option>Eastern Standard Time</option>
         <option>Greenwich Mean Time</option>
        </select> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="menu === 'report-table'"
          class="grid grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8"
        >
          <div>
            <h2 class="text-base font-semibold leading-7">
              Intervalles de temps
            </h2>
            <!-- <p class="mt-1 text-sm leading-6 text-gray-400">
       Rapport détaillé tableau configuation
      </p> -->
          </div>

          <div class="md:col-span-2">
            <div
              class="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6"
            >
              <div class="col-span-full p-4 bg-white rounded-lg shadow-md">
                <label for="email" class="block text-sm font-semibold leading-6"
                  >Nombre d’appels répondus dans un délai de :</label
                >
                <div class="rounded-md py-5">
                  <p class="text-sm font-medium leading-6">
                    {{ $t("timeRange") }}
                  </p>
                  <div class="flex items-center gap-2">
                    <input
                      class="w-full"
                      v-model="form.initial_interval"
                      type="range"
                      id="vol"
                      name="vol"
                      min="10"
                      max="140"
                      step="10"
                    />
                    <span class="text-xs text-gray-500 font-medium">
                      {{ form.initial_interval }}(s)
                    </span>
                  </div>
                </div>
                <div class="rounded-md py-5">
                  <p class="text-sm font-medium leading-6">
                    {{ $t("timeGap") }}
                  </p>
                  <div class="flex items-center gap-2">
                    <input
                      class="w-full"
                      v-model="form.following_interval"
                      type="range"
                      id="vol"
                      name="vol"
                      min="10"
                      max="40"
                      step="10"
                    />
                    <span class="text-xs text-gray-500 font-medium">
                      {{ form.following_interval }}(s)
                    </span>
                  </div>
                </div>

                <div class="rounded-md py-5">
                  <p class="text-sm font-medium leading-6">
                    {{ $t("columns") }}
                  </p>
                  <div class="flex items-center gap-2">
                    <input
                      class="w-full"
                      v-model="form.count_interval"
                      type="range"
                      id="vol"
                      name="vol"
                      min="1"
                      max="5"
                      step="1"
                    />
                    <span class="text-xs text-gray-500 font-medium">
                      {{ form.count_interval }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h2 class="text-base font-semibold leading-7">Alertes visuelles</h2>
            <!-- <p class="mt-1 text-sm leading-6 text-gray-400">
       Rapport détaillé tableau configuation
      </p> -->
          </div>

          <div class="md:col-span-2">
            <div
              class="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6"
            >
              <!-- Répondu % Section -->
              <div class="col-span-full p-4 bg-white rounded-lg shadow-md">
                <div class="flex justify-between items-center mb-4">
                  <label class="block text-sm font-semibold leading-6">
                    Taux de réponse :
                  </label>
                  <div>
                    <button
                      @click.prevent="activateAll('answered_percentage')"
                      class="text-sm text-green-600 hover:underline"
                    >
                      Activer tout
                    </button>
                    <button
                      @click.prevent="deactivateAll('answered_percentage')"
                      class="text-sm text-red-600 hover:underline ml-4"
                    >
                      Désactiver tout
                    </button>
                  </div>
                </div>

                <!-- Niveau Rouge -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.answered_percentage_red_value"
                      class="form-input w-24 py-1"
                      min="0"
                      :max="form.answered_percentage_orange_value"
                    />
                    <span>%</span>
                  </div>
                  <p
                    class="text-sm text-red-500 bg-red-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Rouge &le; {{ form.answered_percentage_red_value }}%
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.answered_percentage_red_active"
                      class="form-checkbox text-red-600 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Orange -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.answered_percentage_orange_value"
                      class="form-input w-24 py-1"
                      :min="form.answered_percentage_red_value"
                      :max="form.answered_percentage_yellow_value"
                    />
                    <span>%</span>
                  </div>
                  <p
                    class="text-sm text-orange-600 bg-orange-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Orange {{ form.answered_percentage_red_value }}% &lt;
                    % &le; {{ form.answered_percentage_orange_value }}%
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.answered_percentage_orange_active"
                      class="form-checkbox text-orange-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Jaune -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.answered_percentage_yellow_value"
                      class="form-input w-24 py-1"
                      :min="form.answered_percentage_orange_value"
                      :max="form.answered_percentage_green_value"
                    />
                    <span>%</span>
                  </div>
                  <p
                    class="text-sm text-yellow-500 bg-yellow-100 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Jaune {{ form.answered_percentage_orange_value }}%
                    &lt; % &le; {{ form.answered_percentage_yellow_value }}%
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.answered_percentage_yellow_active"
                      class="form-checkbox text-yellow-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Vert -->
                <div class="flex items-center justify-between py-2">
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.answered_percentage_green_value"
                      class="form-input w-24 py-1"
                      :min="form.answered_percentage_yellow_value"
                      max="100"
                    />
                    <span>%</span>
                  </div>
                  <p
                    class="text-sm text-green-500 bg-green-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Vert &gt; {{ form.answered_percentage_green_value }}%
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.answered_percentage_green_active"
                      class="form-checkbox text-green-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>
              </div>

              <!-- Durée d'attente Moyenne Queue Section -->
              <div class="col-span-full p-4 bg-white rounded-lg shadow-md">
                <div class="flex justify-between items-center mb-4">
                  <label class="block text-sm font-semibold leading-6">
                    Durée d'attente Moyenne Files :
                  </label>
                  <div>
                    <button
                      @click.prevent="activateAll('duration_avg_answer')"
                      class="text-sm text-green-600 hover:underline"
                    >
                      Activer tout
                    </button>
                    <button
                      @click.prevent="deactivateAll('duration_avg_answer')"
                      class="text-sm text-red-600 hover:underline ml-4"
                    >
                      Désactiver tout
                    </button>
                  </div>
                </div>

                <!-- Niveau Rouge -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_answer_red_value"
                      class="form-input w-24 py-1"
                      :min="form.duration_avg_answer_orange_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-red-500 bg-red-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Rouge &gt;
                    {{ form.duration_avg_answer_red_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_answer_red_active"
                      class="form-checkbox text-red-600 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Orange -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_answer_orange_value"
                      class="form-input w-24 py-1"
                      :min="form.duration_avg_answer_yellow_value"
                      :max="form.duration_avg_answer_red_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-orange-600 bg-orange-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Orange
                    {{ form.duration_avg_answer_orange_value }} sec &lt; s &le;
                    {{ form.duration_avg_answer_red_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_answer_orange_active"
                      class="form-checkbox text-orange-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Jaune -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_answer_yellow_value"
                      class="form-input w-24 py-1"
                      :min="form.duration_avg_answer_green_value"
                      :max="form.duration_avg_answer_orange_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-yellow-500 bg-yellow-100 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Jaune {{ form.duration_avg_answer_yellow_value }} sec
                    &lt; s &le; {{ form.duration_avg_answer_orange_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_answer_yellow_active"
                      class="form-checkbox text-yellow-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Vert -->
                <div class="flex items-center justify-between py-2">
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_answer_green_value"
                      class="form-input w-24 py-1"
                      min="0"
                      :max="form.duration_avg_answer_yellow_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-green-500 bg-green-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Vert &le;
                    {{ form.duration_avg_answer_green_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_answer_green_active"
                      class="form-checkbox text-green-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>
              </div>

              <!-- Durée d'attente Moyenne Extension Section -->
              <div class="col-span-full p-4 bg-white rounded-lg shadow-md">
                <div class="flex justify-between items-center mb-4">
                  <label class="block text-sm font-semibold leading-6">
                    Durée d'attente Moyenne Utilisateurs :
                  </label>
                  <div>
                    <button
                      @click.prevent="activateAll('duration_avg_answer_user')"
                      class="text-sm text-green-600 hover:underline"
                    >
                      Activer tout
                    </button>
                    <button
                      @click.prevent="deactivateAll('duration_avg_answer_user')"
                      class="text-sm text-red-600 hover:underline ml-4"
                    >
                      Désactiver tout
                    </button>
                  </div>
                </div>

                <!-- Niveau Rouge -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_answer_user_red_value"
                      class="form-input w-24 py-1"
                      :min="form.duration_avg_answer_user_orange_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-red-500 bg-red-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Rouge &gt;
                    {{ form.duration_avg_answer_user_red_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_answer_user_red_active"
                      class="form-checkbox text-red-600 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Orange -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_answer_user_orange_value"
                      class="form-input w-24 py-1"
                      :min="form.duration_avg_answer_user_yellow_value"
                      :max="form.duration_avg_answer_user_red_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-orange-600 bg-orange-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Orange
                    {{ form.duration_avg_answer_user_orange_value }} sec &lt; s
                    &le; {{ form.duration_avg_answer_user_red_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_answer_user_orange_active"
                      class="form-checkbox text-orange-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Jaune -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_answer_user_yellow_value"
                      class="form-input w-24 py-1"
                      :min="form.duration_avg_answer_user_green_value"
                      :max="form.duration_avg_answer_user_orange_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-yellow-500 bg-yellow-100 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Jaune
                    {{ form.duration_avg_answer_user_yellow_value }} sec &lt; s
                    &le; {{ form.duration_avg_answer_user_orange_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_answer_user_yellow_active"
                      class="form-checkbox text-yellow-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Vert -->
                <div class="flex items-center justify-between py-2">
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_answer_user_green_value"
                      class="form-input w-24 py-1"
                      min="0"
                      :max="form.duration_avg_answer_user_yellow_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-green-500 bg-green-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Vert &le;
                    {{ form.duration_avg_answer_user_green_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_answer_user_green_active"
                      class="form-checkbox text-green-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>
              </div>

              <!-- Durée d'appel Moyenne Section -->
              <div class="col-span-full p-4 bg-white rounded-lg shadow-md">
                <div class="flex justify-between items-center mb-4">
                  <label class="block text-sm font-semibold leading-6">
                    Durée d'appel Moyenne :
                  </label>
                  <div>
                    <button
                      @click.prevent="activateAll('duration_avg_call')"
                      class="text-sm text-green-600 hover:underline"
                    >
                      Activer tout
                    </button>
                    <button
                      @click.prevent="deactivateAll('duration_avg_call')"
                      class="text-sm text-red-600 hover:underline ml-4"
                    >
                      Désactiver tout
                    </button>
                  </div>
                </div>

                <!-- Niveau Rouge -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_call_red_value"
                      class="form-input w-24 py-1"
                      :min="form.duration_avg_call_orange_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-red-500 bg-red-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Rouge &gt; {{ form.duration_avg_call_red_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_call_red_active"
                      class="form-checkbox text-red-600 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Orange -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_call_orange_value"
                      class="form-input w-24 py-1"
                      :min="form.duration_avg_call_yellow_value"
                      :max="form.duration_avg_call_red_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-orange-600 bg-orange-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Orange {{ form.duration_avg_call_orange_value }} sec
                    &lt; s &le; {{ form.duration_avg_call_red_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_call_orange_active"
                      class="form-checkbox text-orange-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Jaune -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_call_yellow_value"
                      class="form-input w-24 py-1"
                      :min="form.duration_avg_call_green_value"
                      :max="form.duration_avg_call_orange_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-yellow-500 bg-yellow-100 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Jaune {{ form.duration_avg_call_yellow_value }} sec
                    &lt; s &le; {{ form.duration_avg_call_orange_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_call_yellow_active"
                      class="form-checkbox text-yellow-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Vert -->
                <div class="flex items-center justify-between py-2">
                  <div class="flex gap-1 items-center">
                    <input
                      type="number"
                      v-model="form.duration_avg_call_green_value"
                      class="form-input w-24 py-1"
                      min="0"
                      :max="form.duration_avg_call_yellow_value"
                    />
                    <span>sec</span>
                  </div>
                  <p
                    class="text-sm text-green-500 bg-green-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Vert &le;
                    {{ form.duration_avg_call_green_value }} sec
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.duration_avg_call_green_active"
                      class="form-checkbox text-green-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>
              </div>
              <!-- Ratio Appels vs Sollicitations Section -->
              <div class="col-span-full p-4 bg-white rounded-lg shadow-md">
                <div class="flex justify-between items-center mb-4">
                  <label class="block text-sm font-semibold leading-6">
                    Ratio Appels vs Sollicitations :
                  </label>
                  <div>
                    <button
                      @click.prevent="activateAll('ratio_solicitations')"
                      class="text-sm text-green-600 hover:underline"
                    >
                      Activer tout
                    </button>
                    <button
                      @click.prevent="deactivateAll('ratio_solicitations')"
                      class="text-sm text-red-600 hover:underline ml-4"
                    >
                      Désactiver tout
                    </button>
                  </div>
                </div>

                <!-- Niveau Rouge -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <input
                    type="number"
                    step="0.01"
                    v-model="form.ratio_solicitations_red_value"
                    class="form-input w-24 py-1"
                    :min="form.ratio_solicitations_orange_value"
                  />
                  <p
                    class="text-sm text-red-500 bg-red-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Rouge &gt; {{ form.ratio_solicitations_red_value }}
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.ratio_solicitations_red_active"
                      class="form-checkbox text-red-600 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Orange -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <input
                    type="number"
                    step="0.01"
                    v-model="form.ratio_solicitations_orange_value"
                    class="form-input w-24 py-1"
                    :min="form.ratio_solicitations_yellow_value"
                    :max="form.ratio_solicitations_red_value"
                  />
                  <p
                    class="text-sm text-orange-600 bg-orange-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Orange
                    {{ form.ratio_solicitations_orange_value }} &lt; ratio &le;
                    {{ form.ratio_solicitations_red_value }}
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.ratio_solicitations_orange_active"
                      class="form-checkbox text-orange-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Jaune -->
                <div
                  class="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <input
                    type="number"
                    step="0.01"
                    v-model="form.ratio_solicitations_yellow_value"
                    class="form-input w-24 py-1"
                    :min="form.ratio_solicitations_green_value"
                    :max="form.ratio_solicitations_orange_value"
                  />
                  <p
                    class="text-sm text-yellow-500 bg-yellow-100 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Jaune
                    {{ form.ratio_solicitations_yellow_value }} &lt; ratio &le;
                    {{ form.ratio_solicitations_orange_value }}
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.ratio_solicitations_yellow_active"
                      class="form-checkbox text-yellow-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>

                <!-- Niveau Vert -->
                <div class="flex items-center justify-between py-2">
                  <input
                    type="number"
                    step="0.01"
                    v-model="form.ratio_solicitations_green_value"
                    class="form-input w-24 py-1"
                    min="0"
                    :max="form.ratio_solicitations_yellow_value"
                  />
                  <p
                    class="text-sm text-green-500 bg-green-200 font-semibold rounded-full px-2 py-1"
                  >
                    Niveau Vert &le; {{ form.ratio_solicitations_green_value }}
                  </p>
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      v-model="form.ratio_solicitations_green_active"
                      class="form-checkbox text-green-500 h-5 w-5 rounded"
                    />
                    <!-- <span class="ml-2 text-sm text-gray-600">Activé</span> -->
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-0 flex justify-end">
          <button
            v-if="menu !== 'groups'"
            type="submit"
            class="capitalize w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 body__header--button text-base font-medium text-white sm:w-auto sm:text-sm"
          >
            {{ $t("validate") }}
          </button>
        </div>
      </form>
      <!-- Pre-answer Time Configuration -->
      <div v-if="menu === 'queue'" class="mt-10">
        <!-- Tabs -->
        <div class="mt-10 border-b border-gray-200">
          <nav class="-mb-px flex space-x-6">
            <button
              @click="activeTab = 'current'"
              :class="[
                activeTab === 'current'
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                'whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors',
              ]"
            >
              {{ $t("Configurations actuelles") }}
            </button>
            <button
              @click="activeTab = 'history'"
              :class="[
                activeTab === 'history'
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                'whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors',
              ]"
            >
              {{ $t("Histoire") }}
            </button>
          </nav>
        </div>

        <div>
          <!-- Delete Selected Button -->
          <div v-if="selectedItems.length > 0" class="mt-2 flex justify-end">
            <button
              @click.prevent="bulkDeletePreanswerTimes()"
              class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-2 rounded text-sm"
            >
              {{ $t("Supprimer la sélection") }}
              ({{ selectedItems.length }})
            </button>
          </div>

          <!-- Current Table -->
          <div v-if="activeTab === 'current'" class="mt-2">
            <div class="flex gap-4 justify-end">
              <input
                v-model="filters.queue"
                @input="fetchPreanswerTimes()"
                :placeholder="$t('search')"
                class="px-3 py-2 border rounded w-1/3 text-xs"
              />
            </div>
            <table
              class="min-w-full text-sm text-left border shadow rounded-lg mt-1"
            >
              <thead class="bg-gray-50 text-gray-700 uppercase text-xs">
                <tr>
                  <th class="px-4 py-3 w-10">
                    <!-- Select All Checkbox -->
                    <input
                      type="checkbox"
                      @change="toggleSelectAll('current')"
                      :checked="isAllSelected('current')"
                      class="form-checkbox text-indigo-600 h-4 w-4 rounded"
                    />
                  </th>
                  <th class="px-4 py-3">{{ $t("queue") }}</th>
                  <th class="px-4 py-3">{{ $t("temps de pré-réponse") }}</th>
                  <th class="px-4 py-3">{{ $t("créé par") }}</th>
                  <th class="px-4 py-3 sr-only">{{ $t("Actions") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="record in preanswerCurrent"
                  :key="record.id"
                  class="border-b hover:bg-gray-50"
                >
                  <td class="px-4 py-3">
                    <input
                      type="checkbox"
                      v-model="selectedItems"
                      :value="record.id"
                      class="form-checkbox text-indigo-600 h-4 w-4 rounded"
                    />
                  </td>
                  <td class="px-4 py-3">
                    {{ record.queue }} -
                    {{
                      pbxMap?.call_queues[record.queue]?.name ?? "Unknown Queue"
                    }}
                  </td>
                  <td class="px-4 py-3">{{ record.preanswer_seconds }}s</td>
                  <td class="px-4 py-3">{{ record.created_by || "-" }}</td>
                  <td class="px-4 py-3">
                    <button
                      @click.prevent="deletePreanswerTime(record.id)"
                      :class="`rounded-md hover:bg-red-50 hover:text-red-500 hover:ring-inset hover:ring-1 hover:ring-red-500 text-gray-700 relative -ml-px inline-flex items-center bg-white px-2 py-1 text-sm font-semibold ring-1 ring-inset ring-gray-300 focus:z-10`"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        class="w-4 h-4"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- History Filters -->
          <div v-if="activeTab === 'history'" class="mt-2 space-y-1">
            <div class="flex gap-4 justify-end">
              <input
                v-model="filters.queue"
                @input="fetchPreanswerTimes(1)"
                :placeholder="$t('search')"
                class="px-3 py-2 border rounded w-1/3 text-xs"
              />
            </div>

            <!-- History Table -->
            <table
              class="min-w-full text-sm text-left border shadow rounded-lg"
            >
              <thead class="bg-gray-50 text-gray-700 uppercase text-xs">
                <tr>
                  <th class="px-4 py-3 w-10">
                    <!-- Select All Checkbox -->
                    <input
                      type="checkbox"
                      @change="toggleSelectAll('history')"
                      :checked="isAllSelected('history')"
                      class="form-checkbox text-indigo-600 h-4 w-4 rounded"
                    />
                  </th>
                  <th class="px-4 py-3">{{ $t("queue") }}</th>
                  <th class="px-4 py-3">{{ $t("temps de pré-réponse") }}</th>
                  <th class="px-4 py-3">{{ $t("créé à") }}</th>
                  <th class="px-4 py-3">{{ $t("créé par") }}</th>
                  <th class="px-4 py-3 sr-only">{{ $t("Actions") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="record in preanswerHistory.data"
                  :key="record.id"
                  class="border-b hover:bg-gray-50"
                >
                  <td class="px-4 py-3">
                    <input
                      type="checkbox"
                      v-model="selectedItems"
                      :value="record.id"
                      class="form-checkbox text-indigo-600 h-4 w-4 rounded"
                    />
                  </td>
                  <td class="px-4 py-3">
                    {{ record.queue }} -
                    {{
                      pbxMap?.call_queues[record.queue]?.name ?? "Unknown Queue"
                    }}
                  </td>
                  <td class="px-4 py-3">{{ record.preanswer_seconds }}s</td>
                  <td class="px-4 py-3">
                    {{ new Date(record.created_at).toLocaleString() }}
                  </td>
                  <td class="px-4 py-3">{{ record.created_by || "-" }}</td>
                  <td class="px-4 py-3">
                    <button
                      @click.prevent="deletePreanswerTime(record.id)"
                      :class="`rounded-md hover:bg-red-50 hover:text-red-500 hover:ring-inset hover:ring-1 hover:ring-red-500 text-gray-700 relative -ml-px inline-flex items-center bg-white px-2 py-1 text-sm font-semibold ring-1 ring-inset ring-gray-300 focus:z-10`"
                    >
                      <!-- {{ $t("Delete") }} -->
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        class="w-4 h-4"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination -->
            <div class="flex justify-between items-center mt-2">
              <button
                :disabled="preanswerHistory.current_page === 1"
                @click.prevent="changePage(preanswerHistory.current_page - 1)"
                class="capitalize w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 body__header--button text-base font-medium text-white sm:w-auto sm:text-sm"
              >
                {{ $t("Prev") }}
              </button>
              <span class="text-sm text-gray-600">
                {{ preanswerHistory.current_page }} /
                {{ preanswerHistory.last_page }}
              </span>
              <button
                :disabled="
                  preanswerHistory.current_page === preanswerHistory.last_page
                "
                @click.prevent="changePage(preanswerHistory.current_page + 1)"
                class="capitalize w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 body__header--button text-base font-medium text-white sm:w-auto sm:text-sm"
              >
                {{ $t("Next") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ask-confirmation-dialog
    ref="askConfirmationDialog"
  ></ask-confirmation-dialog>
</template>

<script>
import PageHeading from "../../components/PageHeading.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import Pbx3cxQueuePreanswerTimeConfiguration from "../../components/PBX/Pbx3cxQueuePreanswerTimeConfiguration.vue";
import AskConfirmationDialog from "../../components/AskConfirmationDialog.vue";
const secondaryNavigation = [
  { name: "Groupes", href: "groups", current: false },
  { name: "Agent", href: "agent", current: false },
  { name: "Files d'attente", href: "queue", current: false },
  { name: "report detail", href: "report-table", current: false },
  { name: "pbx host", href: "pbx", current: false },
];
const navigation_groups = [
  { name: "numéros", href: "did" },
  { name: "files", href: "queue" },
  { name: "utilisateurs", href: "extension" },
];
export default {
  props: ["menu", "getPbxHosts"],
  components: {
    PageHeading,
    Pbx3cxQueuePreanswerTimeConfiguration,
    AskConfirmationDialog,
  },
  data() {
    return {
      selectedItems: [],
      activeTab: "current",
      filters: { queue: "", user_id: "" },
      elementGroupsQueueList: [],
      queueList: [],
      elementListConcatReduce: [],
      elementGroups: [],
      elementGroupsQueues: [],
      elementsDataQueues: {},
      groupName: "",
      selectedPbxElements: [],
      selectedElementsLength: 0,
      selectedPbxElementsCount: {},
      elementGroupMap: {},
      groupSelectedFromPbxConfiguration: false,
      navigation_groups,
      secondaryNavigation,
      preanswerCurrent: [],
      preanswerHistory: {
        data: [],
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 1,
      },
      agentForm: {
        host_name: null,
        status_custom1: null,
        status_custom2: null,
      },
      queue_preanswer_form: {
        preanswer_seconds: 0,
      },
      form: {
        customer_code: null,
        host_name: null,
        initial_interval: 20,
        following_interval: 20,
        count_interval: 4,
        // Répondu % Values
        answered_percentage_red_value: 0,
        answered_percentage_orange_value: 60,
        answered_percentage_yellow_value: 70,
        answered_percentage_green_value: 80,
        answered_percentage_red_active: false,
        answered_percentage_orange_active: false,
        answered_percentage_yellow_active: false,
        answered_percentage_green_active: false,

        // Durée d'attente Moyenne Values
        duration_avg_answer_red_value: 60,
        duration_avg_answer_orange_value: 50,
        duration_avg_answer_yellow_value: 40,
        duration_avg_answer_green_value: 30,
        duration_avg_answer_red_active: false,
        duration_avg_answer_orange_active: false,
        duration_avg_answer_yellow_active: false,
        duration_avg_answer_green_active: false,

        // Durée d'attente Moyenne User Values
        duration_avg_answer_user_red_value: 60,
        duration_avg_answer_user_orange_value: 50,
        duration_avg_answer_user_yellow_value: 40,
        duration_avg_answer_user_green_value: 30,
        duration_avg_answer_user_red_active: false,
        duration_avg_answer_user_orange_active: false,
        duration_avg_answer_user_yellow_active: false,
        duration_avg_answer_user_green_active: false,

        // Durée d'appel Moyenne Values
        duration_avg_call_red_value: 60,
        duration_avg_call_orange_value: 50,
        duration_avg_call_yellow_value: 40,
        duration_avg_call_green_value: 30,
        duration_avg_call_red_active: false,
        duration_avg_call_orange_active: false,
        duration_avg_call_yellow_active: false,
        duration_avg_call_green_active: false,

        // Ratio Appels vs Sollicitations Values
        ratio_solicitations_red_value: 1.5,
        ratio_solicitations_orange_value: 1.25,
        ratio_solicitations_yellow_value: 1.1,
        ratio_solicitations_green_value: 1.0,
        ratio_solicitations_red_active: false,
        ratio_solicitations_orange_active: false,
        ratio_solicitations_yellow_active: false,
        ratio_solicitations_green_active: false,
      },
    };
  },
  methods: {
    clearAll() {
      this.selectedPbxElements.length = 0;
      this.$store.dispatch("groupSelected", false);
      this.$store.dispatch("groupSelectedName", []);
    },
    selectAll() {
      this.selectedPbxElements = this.queueList.map(({ value }) => value);
      this.$store.dispatch("groupSelected", false);
      this.$store.dispatch("groupSelectedName", []);
    },
    async fetchPreanswerTimes(page = 1) {
      if (!this.hostName) return;

      let url = `${localStorage.getItem("apiUrl")}/api/v1.2/${
        this.hostName
      }/preanswer-times?page=${page}`;

      if (this.filters.queue) {
        url += `&queue=${encodeURIComponent(this.filters.queue)}`;
      }
      if (this.filters.user_id) {
        url += `&user_id=${this.filters.user_id}`;
      }

      try {
        const { data } = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("apiToken"),
          },
        });
        console.log("data ==> ", data);
        this.preanswerCurrent = data.current;
        this.preanswerHistory = data.history;
      } catch (err) {
        this.errorHandling(err);
      }
    },
    async deletePreanswerTime(id) {
      let title = this.$t("deleteMessageTitle");
      let confirmationMessage = this.$t("confirmationMessage");
      let confirmButton = this.$t("delete");
      let goBack = this.$t("cancel");
      const options = {
        method: "DELETE",
        url: `${localStorage.getItem("apiUrl")}/api/v1.2/${
          this.hostName
        }/preanswer-times/bulk`,
        data: {
          ids: [id],
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("apiToken"),
        },
      };
      const r = await this.$refs.askConfirmationDialog.show({
        title: title,
        message: confirmationMessage,
        okButton: confirmButton,
        cancelButton: goBack,
        action: "delete",
      });
      if (r) {
        axios
          .request(options)
          .then(() => {
            this.fetchPreanswerTimes();
            this.selectedItems.length = 0;
            this.$emit("activeBanner");
            this.$emit("success", true);
            this.$emit("successMsg", this.$t("successMsg"));
          })
          .catch((error) => {
            this.$emit("activeBanner");
            this.$emit("success", false);
            this.$emit("successMsg", this.errorDataResponse);
            this.errorHandling(error);
          });
      }
    },
    async bulkDeletePreanswerTimes() {
      let title = this.$t("deleteMessageTitle");
      let confirmationMessage = this.$t("confirmationMessage");
      let confirmButton = this.$t("delete");
      let goBack = this.$t("cancel");
      console.log("this.selectedItems ==> ", this.selectedItems);
      if (this.selectedItems.length === 0) {
        this.$emit("activeBanner");
        this.$emit("successMsg", this.$t("Please select items to delete."));
        this.$emit("success", false);
        return;
      }

      const options = {
        method: "DELETE",
        url: `${localStorage.getItem("apiUrl")}/api/v1.2/${
          this.hostName
        }/preanswer-times/bulk`,
        data: {
          ids: this.selectedItems,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("apiToken"),
        },
      };
      const r = await this.$refs.askConfirmationDialog.show({
        title: title,
        message: confirmationMessage,
        okButton: confirmButton,
        cancelButton: goBack,
        action: "delete",
      });
      if (r) {
        axios
          .request(options)
          .then(() => {
            this.fetchPreanswerTimes(); // Refresh the table
            this.selectedItems.length = 0;
            this.$emit("activeBanner");
            this.$emit("success", true);
            this.$emit("successMsg", this.$t("successMsg"));
          })
          .catch((error) => {
            this.$emit("activeBanner");
            this.$emit("success", false);
            this.$emit("successMsg", this.errorDataResponse);
            this.errorHandling(error);
          });
      }
    },
    isAllSelected(tab) {
      const records =
        tab === "current" ? this.preanswerCurrent : this.preanswerHistory.data;
      if (records.length === 0) {
        return false;
      }
      return records.every((record) => this.selectedItems.includes(record.id));
    },
    toggleSelectAll(tab) {
      const records =
        tab === "current" ? this.preanswerCurrent : this.preanswerHistory.data;
      const allSelected = this.isAllSelected(tab);
      if (allSelected) {
        this.selectedItems = this.selectedItems.filter(
          (id) => !records.map((r) => r.id).includes(id)
        );
      } else {
        const newIds = records.map((r) => r.id);
        this.selectedItems = [...new Set([...this.selectedItems, ...newIds])];
      }
    },
    async changePage(page) {
      this.fetchPreanswerTimes(page);
    },
    addPbxElement(element) {
      let elementValue = null;
      if (typeof element.value !== "object") {
        elementValue = element?.value?.split(" ")[0].replace(/[^0-9]/g, "");
      }
      let groupsSelected = this.groupSelectedName;
      if (
        element &&
        element.value &&
        element.value.length > 0 &&
        typeof element.value === "object"
      ) {
        let arrayLength = element.value.length;
        this.enabled = arrayLength > 1;
        this.$store.dispatch("groupSelected", true);

        if (!this.elementGroupMap) {
          this.elementGroupMap = {}; // Track groups each element belongs to
        }

        if (!this.selectedPbxElements) {
          this.selectedPbxElements = [];
        }

        let groupIndex = groupsSelected.indexOf(element.label);
        if (groupIndex < 0) {
          groupsSelected.push(element.label);
        } else {
          groupsSelected.splice(groupIndex, 1);
        }

        this.$store.dispatch("groupSelectedName", groupsSelected);

        for (let index = 0; index < arrayLength; index++) {
          let elementIdx = element.value[index];
          elementIdx = elementIdx.split(" ")[0].replace(/[^0-9]/g, "");

          if (!this.elementGroupMap[elementIdx]) {
            this.elementGroupMap[elementIdx] = new Set();
          }

          if (groupsSelected.includes(element.label)) {
            // Selecting the group, add element to tracking map
            this.elementGroupMap[elementIdx].add(element.label);
            if (!this.selectedPbxElements.includes(elementIdx)) {
              this.selectedPbxElements.push(elementIdx);
            }
          } else {
            // Deselecting the group, remove group from element tracking
            this.elementGroupMap[elementIdx].delete(element.label);

            // Remove element only if it is NOT part of any other selected group
            let isStillSelected = false;
            for (let selectedGroup of groupsSelected) {
              if (this.elementGroupMap[elementIdx].has(selectedGroup)) {
                isStillSelected = true;
                break;
              }
            }

            if (!isStillSelected) {
              let elementPos = this.selectedPbxElements.indexOf(elementIdx);
              if (elementPos > -1) {
                this.selectedPbxElements.splice(elementPos, 1);
              }
            }
          }
        }
      } else {
        this.$store.dispatch("groupSelected", false);
        if (elementValue) {
          if (this.selectedPbxElements.length > 0) {
            if (this.selectedPbxElements.indexOf(elementValue) >= 0) {
              this.selectedPbxElements.splice(
                this.selectedPbxElements.indexOf(elementValue),
                1
              );
            } else {
              this.selectedPbxElements.push(elementValue);
            }
          } else {
            this.selectedPbxElements.push(elementValue);
          }
        }
      }
      this.$store.dispatch("pbxElements", this.selectedPbxElements);
      this.$emit("action", this.selectedPbxElements);
    },
    activateAll(section) {
      if (section === "answered_percentage") {
        this.form.answered_percentage_red_active = true;
        this.form.answered_percentage_orange_active = true;
        this.form.answered_percentage_yellow_active = true;
        this.form.answered_percentage_green_active = true;
      } else if (section === "duration_avg_answer") {
        this.form.duration_avg_answer_red_active = true;
        this.form.duration_avg_answer_orange_active = true;
        this.form.duration_avg_answer_yellow_active = true;
        this.form.duration_avg_answer_green_active = true;
      } else if (section === "duration_avg_answer_user") {
        this.form.duration_avg_answer_user_red_active = true;
        this.form.duration_avg_answer_user_orange_active = true;
        this.form.duration_avg_answer_user_yellow_active = true;
        this.form.duration_avg_answer_user_green_active = true;
      } else if (section === "duration_avg_call") {
        this.form.duration_avg_call_red_active = true;
        this.form.duration_avg_call_orange_active = true;
        this.form.duration_avg_call_yellow_active = true;
        this.form.duration_avg_call_green_active = true;
      } else if (section === "ratio_solicitations") {
        this.form.ratio_solicitations_red_active = true;
        this.form.ratio_solicitations_orange_active = true;
        this.form.ratio_solicitations_yellow_active = true;
        this.form.ratio_solicitations_green_active = true;
      }
    },
    deactivateAll(section) {
      if (section === "answered_percentage") {
        this.form.answered_percentage_red_active = false;
        this.form.answered_percentage_orange_active = false;
        this.form.answered_percentage_yellow_active = false;
        this.form.answered_percentage_green_active = false;
      } else if (section === "duration_avg_answer") {
        this.form.duration_avg_answer_red_active = false;
        this.form.duration_avg_answer_orange_active = false;
        this.form.duration_avg_answer_yellow_active = false;
        this.form.duration_avg_answer_green_active = false;
      } else if (section === "duration_avg_answer_user") {
        this.form.duration_avg_answer_user_red_active = false;
        this.form.duration_avg_answer_user_orange_active = false;
        this.form.duration_avg_answer_user_yellow_active = false;
        this.form.duration_avg_answer_user_green_active = false;
      } else if (section === "duration_avg_call") {
        this.form.duration_avg_call_red_active = false;
        this.form.duration_avg_call_orange_active = false;
        this.form.duration_avg_call_yellow_active = false;
        this.form.duration_avg_call_green_active = false;
      } else if (section === "ratio_solicitations") {
        this.form.ratio_solicitations_red_active = false;
        this.form.ratio_solicitations_orange_active = false;
        this.form.ratio_solicitations_yellow_active = false;
        this.form.ratio_solicitations_green_active = false;
      }
    },
    getConfigurationValues() {
      let data = this.pbx3cxTableConfig;

      let agentData = this.pbx3cxAgentConfig;

      if (agentData) {
        this.agentForm.status_custom1 = agentData?.status_custom1;
        this.agentForm.status_custom2 = agentData?.status_custom2;
      }

      if (data) {
        this.form.host_name = data?.host_name;
        this.form.initial_interval = data?.initial_interval;
        this.form.following_interval = data?.following_interval;
        this.form.count_interval = data?.count_interval;
        this.form.answered_percentage_red_active =
          data?.answered_percentage_red_active > 0 ? true : false;
        this.form.answered_percentage_orange_active =
          data?.answered_percentage_orange_active > 0 ? true : false;
        this.form.answered_percentage_yellow_active =
          data?.answered_percentage_yellow_active > 0 ? true : false;
        this.form.answered_percentage_green_active =
          data?.answered_percentage_green_active > 0 ? true : false;
        this.form.duration_avg_answer_red_active =
          data?.duration_avg_answer_red_active > 0 ? true : false;
        this.form.duration_avg_answer_orange_active =
          data?.duration_avg_answer_orange_active > 0 ? true : false;
        this.form.duration_avg_answer_yellow_active =
          data?.duration_avg_answer_yellow_active > 0 ? true : false;
        this.form.duration_avg_answer_green_active =
          data?.duration_avg_answer_green_active > 0 ? true : false;
        this.form.duration_avg_call_red_active =
          data?.duration_avg_call_red_active > 0 ? true : false;
        this.form.duration_avg_call_orange_active =
          data?.duration_avg_call_orange_active > 0 ? true : false;
        this.form.duration_avg_call_yellow_active =
          data?.duration_avg_call_yellow_active > 0 ? true : false;
        this.form.duration_avg_call_green_active =
          data?.duration_avg_call_green_active > 0 ? true : false;
        this.form.ratio_solicitations_red_active =
          data?.ratio_solicitations_red_active > 0 ? true : false;
        this.form.ratio_solicitations_orange_active =
          data?.ratio_solicitations_orange_active > 0 ? true : false;
        this.form.ratio_solicitations_yellow_active =
          data?.ratio_solicitations_yellow_active > 0 ? true : false;
        this.form.ratio_solicitations_green_active =
          data?.ratio_solicitations_green_active > 0 ? true : false;

        this.form.duration_avg_answer_user_red_active =
          data?.duration_avg_answer_user_red_active > 0 ? true : false;
        this.form.duration_avg_answer_user_orange_active =
          data?.duration_avg_answer_user_orange_active > 0 ? true : false;
        this.form.duration_avg_answer_user_yellow_active =
          data?.duration_avg_answer_user_yellow_active > 0 ? true : false;
        this.form.duration_avg_answer_user_green_active =
          data?.duration_avg_answer_user_green_active > 0 ? true : false;

        this.form.answered_percentage_red_value =
          data?.answered_percentage_red_value;
        this.form.answered_percentage_orange_value =
          data?.answered_percentage_orange_value;
        this.form.answered_percentage_yellow_value =
          data?.answered_percentage_yellow_value;
        this.form.answered_percentage_green_value =
          data?.answered_percentage_green_value;
        this.form.duration_avg_answer_red_value =
          data?.duration_avg_answer_red_value;
        this.form.duration_avg_answer_orange_value =
          data?.duration_avg_answer_orange_value;
        this.form.duration_avg_answer_yellow_value =
          data?.duration_avg_answer_yellow_value;
        this.form.duration_avg_answer_green_value =
          data?.duration_avg_answer_green_value;

        this.form.duration_avg_answer_user_red_value =
          data?.duration_avg_answer_user_red_value;
        this.form.duration_avg_answer_user_orange_value =
          data?.duration_avg_answer_user_orange_value;
        this.form.duration_avg_answer_user_yellow_value =
          data?.duration_avg_answer_user_yellow_value;
        this.form.duration_avg_answer_user_green_value =
          data?.duration_avg_answer_user_green_value;

        this.form.duration_avg_call_red_value =
          data?.duration_avg_call_red_value;
        this.form.duration_avg_call_orange_value =
          data?.duration_avg_call_orange_value;
        this.form.duration_avg_call_yellow_value =
          data?.duration_avg_call_yellow_value;
        this.form.duration_avg_call_green_value =
          data?.duration_avg_call_green_value;
        this.form.ratio_solicitations_red_value =
          data?.ratio_solicitations_red_value;
        this.form.ratio_solicitations_orange_value =
          data?.ratio_solicitations_orange_value;
        this.form.ratio_solicitations_yellow_value =
          data?.ratio_solicitations_yellow_value;
        this.form.ratio_solicitations_green_value =
          data?.ratio_solicitations_green_value;
      }
      if (!this.form.host_name && this.hostName)
        this.form.host_name = this.hostName;
    },
    sendForm() {
      const url = `${localStorage.getItem(
        "apiUrl"
      )}/api/v1.2/pbx3cx-report-table-configurations`;
      const urlPut = `${localStorage.getItem(
        "apiUrl"
      )}/api/v1.2/pbx3cx-report-table-configurations/${
        this.pbx3cxCustomerCode
      }`;

      if (this.pbx3cxCustomerCode) {
        if (this.pbx3cxTableConfig) {
          axios
            .put(urlPut, this.form, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("apiToken"),
              },
            })
            .then((res) => {
              this.$store.dispatch("hostName", res.data?.host_name);
              localStorage.setItem("hostName", res.data?.host_name);
              this.$store.dispatch("pbx3cxTableConfig", res.data);
              location.reload();
              this.$emit("activeBanner");
              this.$emit("successMsg", this.$t("successMsg"));
              this.$emit("success", true);
            })
            .catch((err) => {
              this.errorHandling(err);
            })
            .finally(() => this.getPbxHosts());
        } else {
          this.form.customer_code = this.pbx3cxCustomerCode;
          axios
            .post(url, this.form, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("apiToken"),
              },
            })
            .then((res) => {
              this.$store.dispatch("hostName", res.data?.host_name);
              localStorage.setItem("hostName", res.data?.host_name);
              this.$store.dispatch("pbx3cxTableConfig", res.data);
              this.$emit("activeBanner");
              this.$emit("successMsg", this.$t("successMsg"));
              this.$emit("success", true);
            })
            .catch((err) => {
              this.errorHandling(err);
            })
            .finally(() => this.getPbxHosts());
        }
      } else {
        this.$emit("activeBanner");
        this.$emit("successMsg", this.$t("onlyAdminMsg"));
        this.$emit("success", false);
      }
    },
    sendFormAgentConfiguration() {
      const url = `${localStorage.getItem(
        "apiUrl"
      )}/api/v1.2/pbx3cx-agent-configurations`;
      const urlPut = `${localStorage.getItem(
        "apiUrl"
      )}/api/v1.2/pbx3cx-agent-configurations/${this.hostName}`;
      if (this.hostName) {
        if (this.pbx3cxAgentConfig) {
          axios
            .put(urlPut, this.agentForm, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("apiToken"),
              },
            })
            .then((res) => {
              this.$store.dispatch("pbx3cxAgentConfig", res.data);
              location.reload();
              this.$emit("activeBanner");
              this.$emit("successMsg", this.$t("successMsg"));
              this.$emit("success", true);
            })
            .catch((err) => {
              this.errorHandling(err);
            })
            .finally(() => this.getPbxHosts());
        } else {
          this.agentForm.host_name = this.hostName;
          axios
            .post(url, this.agentForm, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("apiToken"),
              },
            })
            .then((res) => {
              this.$store.dispatch("pbx3cxAgentConfig", res.data);
              this.$emit("activeBanner");
              this.$emit("successMsg", this.$t("successMsg"));
              this.$emit("success", true);
            })
            .catch((err) => {
              this.errorHandling(err);
            })
            .finally(() => this.getPbxHosts());
        }
      } else {
        this.$emit("activeBanner");
        this.$emit("successMsg", this.$t("onlyAdminMsg"));
        this.$emit("success", false);
      }
    },
    sendFormQueuePreanswerTimeConfiguration() {
      if (this.selectedPbxElements.length === 0) {
        this.$emit("activeBanner");
        this.$emit("successMsg", this.$t("Please select at least one queue."));
        this.$emit("success", false);
        return;
      }

      const configs = this.selectedPbxElements.map((element) => {
        return {
          queue: element,
          label:
            this.pbxMap && this.pbxMap?.call_queues[element]
              ? this.pbxMap.call_queues[element].name
              : null,
          preanswer_seconds: this.queue_preanswer_form.preanswer_seconds,
          created_by: this.user?.name,
        };
      });

      const url = `${localStorage.getItem("apiUrl")}/api/v1.2/${
        this.hostName
      }/preanswer-times/bulk`;

      if (this.hostName) {
        axios
          .post(
            url,
            { configs },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("apiToken"),
              },
            }
          )
          .then((res) => {
            this.fetchPreanswerTimes();
            this.selectedPbxElements = [];
            this.$store.dispatch("groupSelected", false);
            this.$store.dispatch("groupSelectedName", []);
            this.$emit("activeBanner");
            this.$emit("successMsg", this.$t("successMsg"));
            this.$emit("success", true);
          })
          .catch((err) => {
            this.errorHandling(err);
          });
      } else {
        this.$emit("activeBanner");
        this.$emit("successMsg", this.$t("onlyAdminMsg"));
        this.$emit("success", false);
      }
    },
    async getPbxMap() {
      if (this.hostName && this.hostName !== "null") {
        let url = `${localStorage.getItem("apiUrl")}/api/v1.2/${
          this.hostName
        }/map`;
        try {
          const res = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
            },
          });
          this.$store.dispatch("pbxMap", res.data);
          localStorage.setItem("pbxMap", JSON.stringify(res.data));
          this.pbxMapData = res.data;

          if (
            !res.data ||
            (res.data && Object.keys(res.data).length == 0) ||
            (res.data && !res.data.active)
          ) {
            this.$router.push("/page-unavailable");
          }

          return res.data;
        } catch (error) {
          this.errorHandling(error);
        }
      }
    },
    async concatArray() {
      this.$store.dispatch("groupSelected", false);
      this.$store.dispatch("groupSelectedName", []);

      let queueListConcat = [];
      let objQueues = {};
      let objDataGroups = {};
      objDataGroups["methods"] = [];
      let objDataElements = {};
      objDataElements["methods"] = [];
      let queuesArrayGroup = [];
      let queuesOnGroup = [];

      const objectDataGroups = await this.getElementGroups();
      const objectData = await this.getPbxMap();

      if (objectDataGroups?.length || objectData) {
        let objElementGroupsQueueFiltered = {};

        let keysQueues = Object.keys(objectData.call_queues);

        let elementGroupsQueueFiltered = objectDataGroups.filter(
          (res) => res.type == 4
        );

        let elementGroupsQueues = [];

        elementGroupsQueueFiltered.forEach((res) => {
          let arrResources = [];
          let resources = JSON.parse(res.resources);
          resources.forEach((res) =>
            objectData.call_queues[res] && objectData.call_queues[res].name
              ? arrResources.push(`${res}:${objectData.call_queues[res]?.name}`)
              : ""
          );
          objElementGroupsQueueFiltered[res.name] = arrResources;
        });

        elementGroupsQueues = Object.keys(objElementGroupsQueueFiltered);

        elementGroupsQueues.forEach((element, indexEl) => {
          queuesArrayGroup = [];
          objDataGroups = {};
          objQueues = {};
          objQueues["value"] = null;
          objQueues["label"] = null;
          objQueues["type"] = "queue";
          this.elementGroupsQueueList.push(objQueues);

          for (
            let index = 0;
            index < objElementGroupsQueueFiltered[element].length;
            index++
          ) {
            objQueues = {};
            objQueues["value"] = null;
            objQueues["label"] = null;
            const elementExt = objElementGroupsQueueFiltered[element][index];

            let splitElementExt = elementExt
              ? elementExt.split(":")
              : undefined;

            if (splitElementExt && splitElementExt.length > 0) {
              queuesOnGroup.push(splitElementExt[0]);
              objQueues["value"] = splitElementExt[0];
              objQueues["label"] = splitElementExt[0];
              objQueues["group"] = true;
              queuesArrayGroup.push(objQueues);
            }
          }
          objDataGroups["name"] = element;
          objDataGroups["methods"] = queuesArrayGroup;
          this.$route.name === "ExpertStatisticsQueueDetail"
            ? ""
            : queueListConcat.splice(indexEl, 1, objDataGroups);
        });

        let objQueue = {};
        let queuesArray = [];

        // extensionsOnGroup.forEach((element, index) => {
        //   const indexExt = keysExtensions.indexOf(String(element));
        //   if (indexExt > -1) {
        //     keysExtensions.splice(indexExt, 1);
        //   }
        // });

        // queuesOnGroup.forEach((element, index) => {
        //   const indexExt = keysQueues.indexOf(String(element));
        //   if (indexExt > -1) {
        //     keysQueues.splice(indexExt, 1);
        //   }
        // });

        keysQueues.forEach((element, index) => {
          objQueue = {};
          objQueue["value"] = keysQueues[index];
          objQueue["label"] =
            keysQueues[index] + " - " + objectData.call_queues[element].name;
          objQueue["type"] = "queue";
          objQueue["group"] = false;
          this.queueList.push(objQueue);
          queuesArray.push(objQueue);
        });

        objDataElements["name"] = "Elements";
        objDataElements["methods"] = queuesArray;

        queueListConcat.push(objDataElements);

        this.elementListConcatReduce = queueListConcat.reduce(
          (flat, constructor) => {
            return flat
              .concat({
                label: constructor.name,
                value: constructor.methods.map((method) => method.value),
                isConstructor: true,
              })
              .concat(
                constructor.methods.map((method) => ({
                  label: method.label,
                  value: method.value,
                  group: method.group,
                }))
              );
          },
          []
        );
      }

      this.elementListConcatReduce = this.elementListConcatReduce.filter(
        (el) => {
          if (this.isNotMultiple) {
            return !el.isConstructor && !el.group;
          } else {
            return el.label !== "Elements" && (!el.group || el.isConstructor);
          }
        }
      );
    },
    async getElementGroups() {
      let objectData = undefined;
      if (this.hostName && this.hostName !== "null") {
        try {
          const res = await axios.get(
            `${localStorage.getItem("apiUrl")}/api/v1.2/${
              this.hostName
            }/resource-groups`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
              },
            }
          );
          objectData = res.data;
          return objectData;
        } catch (error) {
          this.errorHandling(error);
        }
      }
    },
  },
  mounted() {
    this.getConfigurationValues();
    this.concatArray();
    this.fetchPreanswerTimes();
  },
  computed: {
    ...mapGetters([
      "hostNames",
      "hostName",
      "user",
      "pbx3cxCustomerCode",
      "pbx3cxTableConfig",
      "pbx3cxAgentConfig",
      "pbxMap",
      "pbxElements",
      "groupSelected",
      "groupSelectedName",
    ]),
    navigation() {
      return this.secondaryNavigation.map((nav) => {
        nav.href === this.menu ? (nav.current = true) : (nav.current = false);
        return nav;
      });
    },
  },
  watch: {
    pbx3cxTableConfig: function (val) {
      this.form.host_name = val?.host_name;
      this.form.initial_interval = val?.initial_interval;
      this.form.following_interval = val?.following_interval;
      this.form.count_interval = val?.count_interval;
      this.form.answered_percentage_red_active =
        val?.answered_percentage_red_active > 0 ? true : false;
      this.form.answered_percentage_orange_active =
        val?.answered_percentage_orange_active > 0 ? true : false;
      this.form.answered_percentage_yellow_active =
        val?.answered_percentage_yellow_active > 0 ? true : false;
      this.form.answered_percentage_green_active =
        val?.answered_percentage_green_active > 0 ? true : false;
      this.form.duration_avg_answer_red_active =
        val?.duration_avg_answer_red_active > 0 ? true : false;
      this.form.duration_avg_answer_orange_active =
        val?.duration_avg_answer_orange_active > 0 ? true : false;
      this.form.duration_avg_answer_yellow_active =
        val?.duration_avg_answer_yellow_active > 0 ? true : false;
      this.form.duration_avg_answer_green_active =
        val?.duration_avg_answer_green_active > 0 ? true : false;

      this.form.duration_avg_answer_user_red_active =
        val?.duration_avg_answer_user_red_active > 0 ? true : false;
      this.form.duration_avg_answer_user_orange_active =
        val?.duration_avg_answer_user_orange_active > 0 ? true : false;
      this.form.duration_avg_answer_user_yellow_active =
        val?.duration_avg_answer_user_yellow_active > 0 ? true : false;
      this.form.duration_avg_answer_user_green_active =
        val?.duration_avg_answer_user_green_active > 0 ? true : false;

      this.form.duration_avg_call_red_active =
        val?.duration_avg_call_red_active > 0 ? true : false;
      this.form.duration_avg_call_orange_active =
        val?.duration_avg_call_orange_active > 0 ? true : false;
      this.form.duration_avg_call_yellow_active =
        val?.duration_avg_call_yellow_active > 0 ? true : false;
      this.form.duration_avg_call_green_active =
        val?.duration_avg_call_green_active > 0 ? true : false;
      this.form.ratio_solicitations_red_active =
        val?.ratio_solicitations_red_active > 0 ? true : false;
      this.form.ratio_solicitations_orange_active =
        val?.ratio_solicitations_orange_active > 0 ? true : false;
      this.form.ratio_solicitations_yellow_active =
        val?.ratio_solicitations_yellow_active > 0 ? true : false;
      this.form.ratio_solicitations_green_active =
        val?.ratio_solicitations_green_active > 0 ? true : false;

      this.form.answered_percentage_red_value =
        val?.answered_percentage_red_value;
      this.form.answered_percentage_orange_value =
        val?.answered_percentage_orange_value;
      this.form.answered_percentage_yellow_value =
        val?.answered_percentage_yellow_value;
      this.form.answered_percentage_green_value =
        val?.answered_percentage_green_value;
      this.form.duration_avg_answer_red_value =
        val?.duration_avg_answer_red_value;
      this.form.duration_avg_answer_orange_value =
        val?.duration_avg_answer_orange_value;
      this.form.duration_avg_answer_yellow_value =
        val?.duration_avg_answer_yellow_value;
      this.form.duration_avg_answer_green_value =
        val?.duration_avg_answer_green_value;

      this.form.duration_avg_answer_user_red_value =
        val?.duration_avg_answer_user_red_value;
      this.form.duration_avg_answer_user_orange_value =
        val?.duration_avg_answer_user_orange_value;
      this.form.duration_avg_answer_user_yellow_value =
        val?.duration_avg_answer_user_yellow_value;
      this.form.duration_avg_answer_user_green_value =
        val?.duration_avg_answer_user_green_value;

      this.form.duration_avg_call_red_value = val?.duration_avg_call_red_value;
      this.form.duration_avg_call_orange_value =
        val?.duration_avg_call_orange_value;
      this.form.duration_avg_call_yellow_value =
        val?.duration_avg_call_yellow_value;
      this.form.duration_avg_call_green_value =
        val?.duration_avg_call_green_value;
      this.form.ratio_solicitations_red_value =
        val?.ratio_solicitations_red_value;
      this.form.ratio_solicitations_orange_value =
        val?.ratio_solicitations_orange_value;
      this.form.ratio_solicitations_yellow_value =
        val?.ratio_solicitations_yellow_value;
      this.form.ratio_solicitations_green_value =
        val?.ratio_solicitations_green_value;
    },
    pbx3cxAgentConfig: function (val) {
      this.agentForm.status_custom1 = val?.status_custom1;
      this.agentForm.status_custom2 = val?.status_custom2;
    },
    hostName: function (val) {
      this.concatArray();
    },
  },
};
</script>

<style></style>
